module.exports = __webpack_public_path__ + "img/0120.8289462d.png";